interface RegistrationDocumentsState {
  documentRuleId: string | null;
}

interface SetRegistrationDocumentRuleIdAction {
  type: "SET_REGISTRATION_DOCUMENT_RULE_ID";
  payload: string;
}

interface ResetRegistrationDocumentsAction {
  type: "RESET_REGISTRATION_DOCUMENTS";
}

type RegistrationDocumentsAction =
  | SetRegistrationDocumentRuleIdAction
  | ResetRegistrationDocumentsAction;

const initialState: RegistrationDocumentsState = {
  documentRuleId: null,
};

export const registrationDocumentsReducer = (
  state: RegistrationDocumentsState = initialState,
  action: RegistrationDocumentsAction
): RegistrationDocumentsState => {
  switch (action.type) {
    case "SET_REGISTRATION_DOCUMENT_RULE_ID": {
      return { ...state, documentRuleId: action.payload };
    }
    case "RESET_REGISTRATION_DOCUMENTS": {
      return { ...initialState };
    }
    default:
      return state;
  }
};
